export interface VideoSettings {
  selectedSize: string;
  cameraMotion: string;
  promptStyle: string;
  shotAngle: string;
  shotSize: string;
}

export interface VideoSettingsWithoutSize {
  cameraMotion: string;
  promptStyle: string;
  shotAngle: string;
  shotSize: string;
}

export interface VideoSettingsCameraOnly {
  cameraMotion: string;
}

export interface VideoSize {
  width: number;
  height: number;
  label: string;
}

export const VIDEO_SIZES: Record<string, VideoSize> = {
  '540p': { width: 960, height: 540, label: '540p (960×540)' },
  '720p': { width: 1280, height: 720, label: '720p (1280×720)' },
  '1080p': { width: 1920, height: 1080, label: '1080p (1920×1080)' }
};

export const CAMERA_MOTIONS = [
  { value: '', label: 'cam.none' },
  { value: 'camera pan left', label: 'cam.panLeft' },
  { value: 'camera pan right', label: 'cam.panRight' },
  { value: 'camera zoom in', label: 'cam.zoomIn' },
  { value: 'camera zoom out', label: 'cam.zoomOut' },
  { value: 'camera tilt up', label: 'cam.tiltUp' },
  { value: 'camera tilt down', label: 'cam.tiltDown' },
  { value: 'camera locked down', label: 'cam.locked' },
  { value: 'camera handheld', label: 'cam.handheld' }
];

export const PROMPT_STYLES = [
  { value: '', label: 'style.none' },
  { value: 'anime', label: 'style.anime' },
  { value: '3d', label: 'style.3d' },
  { value: 'fantasy', label: 'style.fantasy' },
  { value: 'cinematic', label: 'style.cinematic' },
  { value: 'claymation', label: 'style.claymation' },
  { value: 'line art', label: 'style.lineArt' },
  { value: 'stop motion', label: 'style.stopMotion' },
  { value: '2d', label: 'style.2d' },
  { value: 'vector art', label: 'style.vectorArt' },
  { value: 'black and white', label: 'style.monochrome' }
];

export const SHOT_ANGLES = [
  { value: '', label: 'angle.none' },
  { value: 'aerial shot', label: 'angle.aerial' },
  { value: 'eye_level shot', label: 'angle.eyeLevel' },
  { value: 'high angle shot', label: 'angle.high' },
  { value: 'low angle shot', label: 'angle.low' },
  { value: 'top-down shot', label: 'angle.topDown' }
];

export const SHOT_SIZES = [
  { value: '', label: 'shotSize.none' },
  { value: 'close-up shot', label: 'shotSize.closeUp' },
  { value: 'extreme close-up', label: 'shotSize.extremeCloseUp' },
  { value: 'medium shot', label: 'shotSize.medium' },
  { value: 'long shot', label: 'shotSize.long' },
  { value: 'extreme long shot', label: 'shotSize.extremeLong' }
];